export default "__VITE_ASSET__CJG_CXFE__"